import React from "react";
import I18n from "i18n-js";
import './translations';

class EditEntrySquarePayment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentBtnIsDisabled: false
        }
        I18n.locale = this.props.locale
        payAmount = this.props.customAmount;
    }

    componentDidMount() {
        $(document).on('change', 'select.js-quantity', ()=>{
            if(jQuery("#card-button")&&jQuery('#owing')){
                jQuery("#card-button").html(`Pay $${Number(jQuery('#owing').val()).toFixed(2)}`)
                this.props.updateTotalOwing(Number(jQuery('#owing').val()).toFixed(2))
            }
        })
    }

    setPayAmount() {
        payAmount = this.props.customAmount;
    }

    displayPayAmountError() {
        if (this.props.customAmount > this.props.entry_total_owing) {
            return {display: "inline"};
        }
        else if (this.props.customAmount <= 0.10) {
            return {display: "inline"};
        }
        else{
            return {display: "none"};
        }
    }

    displayPayAmountErrorMessage() {
        if (this.props.customAmount > this.props.entry_total_owing) {
            return "The inputted amount: $" + this.props.customAmount + " is greater than the total amount owed: $" + this.props.entry_total_owing + ". Please re-enter a valid payment amount.";
        }
        else if (this.props.customAmount <= 0.10) {
            return "Please enter a payment amount of greater than '0.10'";
        }
    }

    isButtonDisabled() {
        return this.props.customAmount > this.props.entry_total_owing  || this.props.customAmount <= 0.10;
    }

    componentDidUpdate(prevProps) {
        if(this.isButtonDisabled() !== this.state.paymentBtnIsDisabled){
            this.setState({paymentBtnIsDisabled: this.isButtonDisabled()});
        }
    }

    render () {
        return (
            <div>
                <div id="invalid-amount-error" style={this.displayPayAmountError()}>{this.displayPayAmountErrorMessage()}</div>
                <div id={"square_payment_form"}>
                    <form id="payment-form">
                        <div id="card-container"></div>
                        <button id="card-button" type="button" disabled={this.state.paymentBtnIsDisabled} onClick={this.setPayAmount()}>{I18n.t("pay", {amount: Number(this.props.customAmount).toFixed(2)})}</button>
                    </form>
                    <div id="payment-status-container"></div>
                </div>
            </div>
        )
    }
}

export default EditEntrySquarePayment